import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createFilter } from 'react-select';
export var defaultOptionFilter = createFilter({
  ignoreCase: true,
  ignoreAccents: true,
  trim: true,
  matchFrom: 'any',
  stringify: function stringify(_ref) {
    var label = _ref.label;
    return label;
  }
});
export var normalizeOptions = function normalizeOptions(options) {
  if (!options) {
    return [];
  }

  var _normalizeOption = function _normalizeOption(option) {
    if (typeof option === 'string') {
      var _option2 = {
        label: option,
        value: option
      };
      return Object.freeze(_objectSpread(_objectSpread({}, _option2), {}, {
        _original: _option2
      }));
    }

    var isDisabled = option.disabled,
        _option = _objectWithoutProperties(option, ["disabled"]);

    if (typeof isDisabled === 'undefined') {
      return Object.freeze(_objectSpread(_objectSpread({}, option), {}, {
        _original: option
      }));
    }

    return Object.freeze(_objectSpread(_objectSpread({}, _option), {}, {
      _original: option,
      isDisabled: isDisabled
    }));
  };

  return options.map(function (option) {
    if (typeof option === 'object' && option.options) {
      var _group = option;

      var _options = _group.options.map(_normalizeOption);

      return Object.freeze(_objectSpread(_objectSpread({}, _group), {}, {
        options: _options,
        _original: _group
      }));
    }

    return _normalizeOption(option);
  });
};